import React from 'react';
import { MapPin } from 'lucide-react';
import { companyInfo } from '../../mock';

const MAP_SRC = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.15830869428!2d-74.119763973046!3d40.697663747513056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24416947c2109%3A0x82765c7404007886!2sBrooklyn%2C%20NY!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus';

const AREA_GROUPS = [
  { title: 'Brooklyn', areas: ['Williamsburg', 'Park Slope', 'Bay Ridge', 'Flatbush', 'Bensonhurst', 'Canarsie', 'Bedford-Stuyvesant', 'Crown Heights', 'Bushwick', 'Sunset Park', 'Fort Greene', 'Red Hook'] },
  { title: 'Queens', areas: ['Astoria', 'Long Island City', 'Flushing', 'Forest Hills', 'Jamaica', 'Ridgewood', 'Woodside', 'Elmhurst'] },
  { title: 'Manhattan', areas: ['Lower East Side', 'East Village', 'Chelsea', 'Midtown', 'Upper East Side', 'Upper West Side'] },
  { title: 'Additional Areas', areas: ['The Bronx (South)', 'Jersey City', 'Hoboken', 'Staten Island (North)'] },
];

const AreaGroup = ({ title, areas }) => (
  <div>
    <h4 className="font-bold text-yellow-500 mb-3 flex items-center">
      <MapPin className="w-5 h-5 mr-2" />
      {title}
    </h4>
    <div className="grid grid-cols-2 gap-2 text-sm text-gray-600">
      {areas.map((area) => <div key={area}>• {area}</div>)}
    </div>
  </div>
);

export const ServiceAreaMap = () => (
  <section className="py-16 bg-white" data-testid="service-area-map-section">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our <span className="text-yellow-500">Service Area</span></h2>
        <div className="w-24 h-1 bg-yellow-400 mx-auto mb-4"></div>
        <p className="text-lg text-gray-600">Professional electrical services throughout Brooklyn and surrounding areas</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
        <div className="bg-gray-50 rounded-2xl shadow-lg overflow-hidden border border-gray-200">
          <iframe src={MAP_SRC} width="100%" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Service Area Map" data-testid="service-area-map"></iframe>
        </div>
        <div className="bg-gray-50 rounded-2xl shadow-lg p-8 border border-gray-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Areas We Serve</h3>
          <div className="space-y-6">
            {AREA_GROUPS.map((group) => <AreaGroup key={group.title} {...group} />)}
          </div>
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              <strong className="text-gray-900">Don't see your area?</strong> Call us at <a href={`tel:${companyInfo.phone}`} className="text-cyan-500 hover:text-yellow-500 font-semibold transition-colors">{companyInfo.phone}</a> to confirm service availability.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
